<script setup lang="ts">
import clsx from 'clsx';

const props = defineProps<{ class?: string }>();
const classes = clsx('flex flex-col gap-0.5', props.class);
</script>

<template>
  <div data-slot="section" :class="classes"><slot /></div>
</template>
